module.exports = __webpack_public_path__ + "img/revoke-icon.7cfe9222.svg";